module.exports = __webpack_public_path__ + "img/4.d36305e1.png";